import styled from 'styled-components';
import {theme} from '@styles/theme';

export const SelectedUsersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
  background-color: ${theme.colors.basic07};
  border-bottom-left-radius: ${theme.roundedMedium};
  border-bottom-right-radius: ${theme.roundedMedium};
  border: 0;
`;

export const SelectedUsersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;

export const SelectedUsersInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SelectedUsersTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AddSubsystemUsersWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DefaultUsersWrapper = styled.div<{addedUsers: string[]}>`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
  background-color: ${theme.colors.basic06};
  border-top-left-radius: ${theme.roundedMedium};
  border-top-right-radius: ${theme.roundedMedium};
  border-bottom-left-radius: ${({addedUsers}) =>
    addedUsers.length ? 0 : theme.roundedMedium};
  border-bottom-right-radius: ${({addedUsers}) =>
    addedUsers.length ? 0 : theme.roundedMedium};
  border: 0;
`;

export const DefaultUsersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;

export const DefaultUsersInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  svg {
    transform: scaleX(-1);
  }
`;

export const DefaultUsersTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubdirectoryWrapper = styled.div`
  position: relative;
`;